import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, PASTE_COMMAND } from 'lexical';
import { useEffect } from 'react';

interface PastePluginProps {
  onPasteFiles?: (files: File[]) => void;
}

export function PastePlugin({ onPasteFiles }: PastePluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!onPasteFiles) return;

    return editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) return false;

        const items = clipboardData.items;
        if (!items) return false;

        const imageFiles: File[] = [];

        // Check for image items in clipboard
        for (let i = 0; i < items.length; i++) {
          const item = items[i];

          if (item.type.startsWith('image/')) {
            const file = item.getAsFile();
            if (file) {
              // Create a proper File object with a meaningful name
              const timestamp = Date.now();
              const extension = file.type.split('/')[1] || 'png';
              const properFile = new File(
                [file],
                `pasted-image-${timestamp}.${extension}`,
                { type: file.type },
              );
              imageFiles.push(properFile);
            }
          }
        }

        // If we found images, handle them and prevent default paste behavior
        if (imageFiles.length > 0) {
          event.preventDefault();
          onPasteFiles(imageFiles);
          return true; // Event handled
        }

        return false; // Not an image paste, let default behavior happen
      },
      COMMAND_PRIORITY_HIGH,
    );
  }, [editor, onPasteFiles]);

  return null;
}
